export default {
      id: "motif-usage",
      viewBox: "0 0 2000 2700",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#motif-usage",
      toString: function () {
        return this.url;
      }
    }